module.exports = __webpack_public_path__ + "static/media/Gift.36106312.png";